<template>
  <div ceo :class="{ready}">
    <SelectContent tit="2025" title="CEO Letter." :list="selectList" :active="active" @select="select"/>
    <div class="ceo-letter" :class="{refresh}">
      <div class="cont cont1" v-if="active === 'kim'">
        <div v-if="lang === 'ko'">
          <div class="txt">
            <h3>■ 2024년의 회고, 2025년과 그 이후를 위한 준비</h3>
            <p>불확실성이 큰 시기에 보령이 우선해야 할 것은 명확합니다. 핵심 사업의 경쟁력을 지속적으로 강화하고 미래 성장에 필요한 전략적 투자를 현명하게 이어가는 것입니다. 작년 말 우리는 제3자 배정 유상증자를 성공적으로 마쳐 재무적 안정성을 크게 향상시켰고, 장기적으로 지속 가능한 성장의 기틀을 마련했습니다.</p>
            <p>보령은 현재의 안정적 재무 구조를 바탕으로 핵심 사업을 통해 창출할 현금흐름과 신중한 조달 전략을 결합하여, 핵심 사업의 경쟁력을 더욱 공고히 하고 미래를 위한 전략적 사업에 투자할 것입니다. 회사의 가치를 높이는 진정한 방법은 장기적 관점을 바탕으로 지속적인 성장을 위한 꾸준한 투자라고 확신하며, 보령이 이를 바탕으로 한 성공한 기업의 대명사가 될 수 있도록 노력하겠습니다.</p>
            <h3>■ 회사의 오너십에 대한 고찰</h3>
            <p>지난 주주총회 이후 보령에서 일어난 가장 큰 변화는 전 영역에서 오너십이 강조되었다는 점입니다. 저는 지금까지 가용할 수 있는 대부분의 자산을 보령에 투자하였고 주주 여러분과 완벽히 이해관계를 일치시켰습니다. 이 자금을 통해서 보령은 장기적으로 유망한 새로운 사업 기회를 모색할 수 있는 강력한 재무 기반을 확보했습니다. 또한 최근 이사회에서의 논의에 따라 제가 단독 대표이사로서 회사를 이끌게 되었습니다.</p>
            <p>또한 핵심 임직원들의 회사에 대한 오너십을 강화하기 위하여 보상 제도에 제한조건부 주식보상 제도를 도입하고자 합니다. 저희 회사는 기존에는 주요 임직원에게 장기 인센티브 목적으로 스톡옵션을 부여했었습니다. 하지만 결과론적으로 기대하는 효과를 발휘하지는 못했는데, 저는 그 이유를 두 가지로 판단합니다.</p>
            <ol>
              <li>1) 스톡옵션에서 “옵션”이라는 용어가 이 주식은 내 것이라는 오너십을 주는 데 한계가 있고, 행사가 이루어지기 전까지는 주주가 아닌 지위가 유지됩니다. 그러다 보니 당초 부여 목적의 장기적 관점의 인센티브로서 기능하는 점에 있어 한계가 있었습니다.</li>
              <li>2) 기존 스톡옵션 대상자는 회사 전체의 사업을 관장하지 않아, 전사적인 사업 진행에 따라 시장에서 정해지는 기업가치와 해당 대상자의 성과가 직접적으로 연결되지 않는 한계가 있었습니다.</li>
            </ol>
            <p>제한조건부 주식보상 제도의 한 가지 방안인 RSA는 부여 즉시 부여 대상자 소유의 주식이 되며, 이에 따른 세금도 바로 지급해야 합니다. 즉, 소유에 대한 책임감이 바로 수반된다는 의미입니다. 이에 위 스톡옵션의 한계를 극복할 수 있는 방안이 될 수 있다고 판단하며, 따라서 보령은 회사에 대한 오너십을 가지고, 장기적 관점에서 회사 전체를 발전시켜나갈 핵심인재에게 RSA를 부여하고자 합니다.</p>
            <p>저는 RSA의 대상자가 아닙니다. RSA를 부여하는 목적이 회사를 장기적으로 함께 끌고 가야 하는 핵심인재들과 회사의 장기적 비전을 일치시키고, 이에 맞는 보상체계를 부여하는 것입니다. 저는 이미 회사의 비전과 이해관계가 일치되어 있기 때문에, 저를 동기부여하기 위한 보상체계는 의미가 없습니다. 회사의 비전에 동참하고자 하는 핵심인재들에게 RSA를 부여하는 것이 장기적 회사의 발전에 더욱 큰 의미가 있다고 믿습니다.</p>
            <p>RSA가 많은 사람들에게 부여되지는 않을 것입니다. 인사위원회와 이사회에서 치열한 논의를 통해 판단하여 회사의 장기적 발전에 꼭 필요하다고 판단되는 소수의 인원들에게 부여될 것입니다. 올해 초 자사주100만 주를 소각하면서, 보유 자사주 전체를 소각하지 않은 이유에 대해서 많은 문의가 있었습니다. 이에 대한 답변은, 회사가 가진 자사주를 기반으로 제한조건부 주식보상 제도를 운영하고자 하기 때문입니다. 저를 포함한 이사회 임원들은 회사의 전체 주식 수를 늘리지 않으며, 회사를 장기적으로 발전시키는데 최선을 다할 핵심 인재가 회사의 오너십(주식)을 가지게 되는 것은 기업 가치에 긍정적이라고 판단합니다.</p>
            <p>사업별 핵심인재 분들은 회사의 전체를 책임지지 않기 때문에, 주식보상보다는 실적에 따른 현금 보상이 합리적이라고 판단하고 있습니다. 사업별로 경쟁력을 키우기 위해서는 영위하는 사업 분야에서 가장 뛰어난 인재들과 함께해야 한다고 믿기에, 보상 체계 또한 이에 맞추어 발전시킬 것입니다. 사업별 핵심인재 분들이 보령이라는 회사 전체의 비전과 사업에 동의하여, 자발적으로 주주가 되기로 결정한다면, 이 또한 회사의 발전과 기업가치에 긍정적인 영향을 줄 것입니다.</p>
            <h3>■ 2024년 사업 성과</h3>
            <p>보령은 ‘투명하고 깨끗한 기업’을 핵심가치로 두고 있습니다. 회사의 지속적인 발전을 위해서는 문화적으로 극도의 투명성, 공정경쟁 문화 정착, 윤리 및 정도경영을 추구하며, 의사결정 과정에서의 실책에 대해서도 인정하고, 향후 어떻게 개선해 나갈 것인지에 대한 논의가 되는 것이 중요하다고 생각합니다.</p>
            <p>2024년에는 저의 실책으로 회사 내 자원 배분이 최적화되지 못했습니다. 매출은 1조 원을 넘어서 중요한 목표를 달성했지만, 영업이익은 705억 원으로 목표에 미치지 못했습니다. 이러한 차이는 전적으로 최종 의사결정자의 자원 배분 착오에 기인합니다. 앞으로는 임직원분들의 헌신이 완전한 성과로 연결될 수 있도록 더욱 효율적인 자원 배분을 위해 노력하겠습니다.</p>
            <p>보령이 영위하는 사업 군을 분류에 따라 두 가지로 나누어 보려고 합니다. 하나는 현재의 현금흐름을 책임지는 핵심 사업이며, 다른 하나는 미래의 성장을 위한 전략 사업입니다. 본 서한 서두에서 말씀드린 것처럼, 보령에게 핵심 사업의 경쟁력을 강화하는 것과 전략 사업의 성장을 도모하는 것은 최우선 과제입니다.</p>
            <p>보령의 핵심 사업인 제약사업은 카나브 및 만성질환군, 항암제, 항생제 등의 포트폴리오와 Co-promotion 상품인 케이캡이 더해져 회사 역사상 처음으로 매출 1조 원을 돌파할 수 있었습니다. 역사상 처음인 것과 더불어 창업주 회장님의 염원이던 목표를 달성하는 데 최선을 다해주신 임직원분들께 감사의 말씀을 드립니다. 이익 측면에서는 효율적 자원 배분을 통해 회사의 추가적인 발전에 기여할 수 있는 부분이 있다는 사실을 파악하였기에, 저를 포함한 경영진이 이 점을 명확히 개선하겠다는 점은 꼭 말씀드리겠습니다.</p>
            <p>또한 2024년에는 국내와 해외를 대상으로 한 필수의약품의 위탁개발생산(CDMO) 사업에서 유의미한 첫 발을 내디뎠습니다. 국내 시장에서는 국민 보건에 꼭 필요한 항생제를 포함한 필수의약품의 CDMO 사업을 확장해나갔고, 글로벌 시장에서도 보령의 CDMO 역량을 확인할 수 있었으며, 이를 통해 향후 추가적인 확장의 기회를 찾아나갈 것입니다.</p>
            <p>보령은 아직은 전략 사업인 우주 의학 사업을 통해 매출이나 이익을 내고 있지는 않습니다. 하지만 장기적 관점에서 국가와 인류를 위해 꼭 필요한 사업이라고 믿고, 우주 의학은 곧 보령이라는 사업 공식을 만들어 가고 있습니다.</p>
            <p>보령의 Humans In Space는 작년 NASA Human Research Program을 공식 파트너로 맞이하였고, 독일 항공우주청(DLR) 연구팀이 대회에 참가하여 우승팀 중 한 팀이 되었으며, 우주라는 공간에서 새롭게 개발될 수 있는 다양한 기술들을 한눈에 볼 수 있는 생태계를 마련하였습니다.</p>
            <p>Axiom Space는 NASA의 Commercial LEO Destination (CLD) 계약을 수주하기 위해 치열하게 경쟁 중이며, 2027년 초 첫 번째 모듈을 국제우주정거장에 도킹하는 계획을 가지고 꾸준히 나아가고 있습니다. 보령도 Axiom의 성공에 의존하는 것이 아닌, 우주의학분야 인프라 확보와 같은 우리만이 할 수 있는 사업에 대한 기회를 지속적으로 탐색하며 개발해 나갈 것입니다.</p>
            <h3>■ 자원 배분의 방향성</h3>
            <p>조직의 자원 배분은 경영진의 가장 중요한 책무 중 하나입니다. 회사에서 어떤 사업이나 기능에 집중을 하느냐에 따라 회사의 발전 방향과 결과가 나오기 때문입니다. 회사의 비전과 방향성이 자원 배분의 첫 번째 기준이 되어야 합니다. 핵심 사업 강화뿐만 아니라 미래 수익을 창출할 전략 사업에도 균형 있게 투자해야 합니다. 이와 같은 ‘투자’에는 단순한 재정적 자원뿐 아니라 인적 자원, 인프라, 시간이라는 소중한 자원에 대한 투자도 포함됩니다.</p>
            <p>핵심 사업인 제약사업은 카나브와 기초 항암제 포트폴리오 등을 바탕으로 기구축된 강력한 영업 인프라를 활용할 수 있는 제품 개발 및 인수를 추진하며, 기존 경쟁력을 강화시켜 나갈 것입니다. 또한 LBA 전략을 통해 확인한 글로벌 오리지널 제품을 생산할 수 있는 역량을 갖춘 생산 인프라를 바탕으로 지속적으로 국내외 기초 필수의약품 생산 기회를 창출해 나갈 것입니다.</p>
            <p>전략 사업인 우주의학 사업은 우주 환경을 활용한 연구에 대한 가치사슬 및 공급망에서 사업의 기회를 찾아 나갈 것입니다. 지금까지는 타 법인에 대한 단순 지분 투자 방식으로 진행되어 왔던 자원 배분 방식을 보령이 직접 주도하며 오너십을 가질 수 있는 방향으로 진행하는 것을 고려하고 있습니다.</p>
            <p>핵심 사업을 강화시키며 장기적 관점으로 책임감 있게 전략 사업을 추진해 나가는 것이 저를 포함한 보령의 경영진과 이사회의 경영 방침이고, 이를 위한 최선의 자원 배분을 위해 노력할 것이며, 이를 달성해 나가는 과정에서 보령은 국가와 인류에 꼭 필요한 회사로 거듭날 것입니다.</p>
            <h3>■ 아이들의 꿈을 우주로: Humans In Space (HIS) Youth</h3>
            <p>우리의 다음 세대가 우리보다 더 많은 도전의 기회를 가질 수 있도록 하는 것이 기업의 의무입니다. 보령은 작년부터 한국과학창의재단과의 협업을 바탕으로 “아이들의 꿈을 우주로”라는 비전 아래 초중고 학생 대상 우주과학 경진대회를 개최했습니다.</p>
            <p>초등학생들은 “우주정거장에서의 하루를 상상해 보세요”라는 주제를 바탕으로 팀을 이루어 그림을 그렸으며, 중·고등학생들은 “우주에서 1년 이상 체류할 시 인체에 생길 수 있는 문제점과 해결 방법”에 대한 실험 설계를 하여, 국내외 전문가들에게 멘토링을 받고, NASA, Axiom Space, Intuitive Machines 등 미국 정부 기관 및 민간 기업을 방문할 수 있는 기회를 가졌었습니다.</p>
            <p>초등학생 20팀의 그림이 선정되었고, 올해 6월 초로 예정되어 있는 Axiom의 4번째 민간 우주인 미션인 Ax-4 미션을 통해서 해당 그림들은 국제우주정거장으로 보내질 것입니다. 그리고 현재 Live로 우리나라와 국제우주정거장을 연결하여 그림을 그린 학생들과 우주인 간의 세션을 기획하고 있습니다.</p>
            <p>우연찮게도 그 기간에 한국계 미국인 우주인 Jonny Kim께서 국제우주정거장에 있을 예정입니다. 그분이 우리나라 아이들 그림을 한국어로 소개해 주는 모습을 혼자 상상해 보며, 언젠가 대한민국 우주인이 우리나라의 우주 자산 안에서 우리나라 아이들과 소통하며 꿈의 크기를 키울 수 있는 날을 만들 것을 다짐했습니다.</p>
            <p>이 대회는 앞으로도 매년 진행될 것이고, 우리나라에서 자라나는 다음 세대가 세상과 인류를 바라보는 관점을 보다 발전시키는데 기여할 것입니다.</p>
            <h3>■ 연례 서한에 대한 생각</h3>
            <p>연례 서한은 주주 분들을 포함한 회사 내외의 모든 사람들과 과거의 의사결정을 돌아보고 이를 통해 배운 교훈과 앞으로 나아갈 방향에 대해 솔직히 공유하는 매우 중요한 기회입니다. 그리고 절대적 투명성을 바탕으로, 회사에서의 성공과 실수 모두를 있는 그대로 나누는 것 또한 저의 책임이라고 믿습니다.</p>
            <p>기업의 가치는 단순한 숫자가 아닌, 사업의 목적과 의미, 기업의 과거, 경영진의 비전 및 미래의 방향성 등 여러 가지가 통합되어 형성됩니다. 저는 앞으로도 이 서한을 통해 솔직한 제 생각을 지속적으로 나누겠습니다. 그리고 이 과정을 통해서 보령이 어떤 회사로 발전하고자 하는지에 대해 지속적으로 소통하며, 주주 분들과 임직원분들의 최대한의 공감대를 형성하는데 노력하고, 회사 가치를 키워가는 데만 노력하도록 하겠습니다.</p>
            <p>그리고 그간 하지 못했던 이야기를 할 수 있는 이만한 기회도 없는 것 같습니다. 지금의 보령이 있기까지는 많은 분들의 노력과 헌신이 있었습니다. “역사를 잊은 자는 미래도 없다”라는 말처럼, 회사의 창립 이후 지금까지 회사에 기여해 주신 모든 분들의 노고에 감사드리며, 회사 발전 과정에 대해 잊지 않고 과거의 노력의 성과가 헛되지 않도록 더욱 노력하겠습니다. 장두현 대표님을 포함한 이전 보령의 리더분들께도 감사하다는 말 전해드립니다.</p>
            <p class="date">2025.03.27</p>
            <p class="sign">CEO & 이사회 의장 김정균 <img src="/images/mo/sign1.png" alt=""></p>
          </div>
        </div>
        <div v-else>
          <div class="txt">            
            <h3>■ Reflections on 2024, Preparing for 2025 and Beyond</h3>
            <p>During times of great uncertainty, our priorities at Boryung remain crystal clear: strengthening the competitive edge of our core businesses and making prudent strategic investments for future growth. At the end of last year, we completed a capital-raise process, significantly enhancing our financial stability and laying a solid foundation for sustainable long-term growth.</p>
            <p>Boryung, with a sound financial structure, aims to reinforce our core businesses by combining prudent financing strategies with cash flows generated from these key areas while strategically investing in promising future ventures. The genuine path to enhancing corporate value lies in continuous, steady investment based on a long-term perspective. We are committed to making Boryung synonymous with sustained success.</p>
            <h3>■ Thoughts on Ownership</h3>
            <p>Since our last shareholder meeting, the most significant change within Boryung has been an intensified emphasis on ownership at every level. I have invested nearly all available assets into Boryung, aligning my interests fully with our shareholders. This capital injection gives us a robust financial base for exploring promising new business opportunities. Furthermore, following recent board discussions, I've assumed the role of sole CEO.</p>
            <p>We're introducing a restricted stock-based compensation program to further cultivate ownership among our key executives, including a Restricted Stock Award (RSA) and Restricted Stock Unit (RSU). Previously, we used stock options as long-term incentives, but they didn't fully deliver the desired results for two reasons:</p>
            <ol>
              <li>1. Stock options inherently carry the limitation of not granting immediate ownership, delaying alignment until exercised.</li>
              <li>2. Executives who received stock options did not manage the entirety of our business, leading to a disconnect between their performance and overall company value.</li>
            </ol>
            <p>For example, RSA shares immediately transfer ownership, and taxes must be paid upfront, instilling an immediate sense of responsibility and ownership. Therefore, RSA addresses the shortcomings of traditional stock options, aligning the interests of key talent with the company’s long-term vision.</p>
            <p>I am not personally receiving any stock-based compensation, as my incentives are already aligned with the company's long-term growth. Such compensations will be granted selectively after thorough discussions by our HR committee and the board, focusing only on those responsible for Boryung’s entirety and indispensable to its future. We partially retained treasury shares after canceling one million early this year to support this RSA initiative without diluting overall equity.</p>
            <p>Since key personnel in individual business units do not manage the entire company, performance-based cash incentives make more sense than stock-based compensation.We must attract and retain the best talent available to enhance competitiveness in each business area. Therefore, our compensation structures will continue to evolve accordingly. However, if these key personnel, sharing our vision for Boryung’s overall growth voluntarily choose to become shareholders, we view this as beneficial for the company’s long-term development and value creation.</p>
            <!-- <p></p> -->
            <h3>■ Business Performance in 2024</h3>
            <p>Boryung places extreme transparency at the heart of our corporate values. Sustainable growth demands a cultural commitment to utmost transparency, a willingness to openly acknowledge mistakes made during decision-making, and clear discussions on improving our approach going forward.</p>
            <p>In 2024, my own misjudgment led to the suboptimal allocation of our internal resources. While we successfully exceeded a key milestone with revenues surpassing 1 trillion KRW, growing 18.3%, we fell short of our operating profit target, generating 70.5 billion KRW, growing 3.2%. This gap is solely attributable to my misjudgments in resource allocation. Going forward, I pledge to allocate resources more efficiently, ensuring the hard work of our team fully translates into optimal results.</p>
            <p>We categorize our businesses into two segments: core business, responsible for stable and strong cash flow, and strategic initiatives aimed at future growth. As mentioned earlier, strengthening the competitive edge of our core business and nurturing the growth of strategic ventures are top priorities for Boryung.</p>
            <p>Our core pharmaceutical business reached a historic milestone by surpassing 1 trillion KRW in revenue for the first time, driven by products such as Kanarb, chronic disease treatments, oncology drugs, antibiotics, and our co-promotion product K-CAB. Achieving this goal, which had long been an aspiration of our founder, reflects the extraordinary dedication of our employees, for which we are immensely grateful. On profitability, we recognize the need for improved resource allocation to unlock additional growth potential, a priority management, including myself, will address clearly.</p>
            <p>In 2024, we also made significant progress in our Contract Development and Manufacturing Organization (CDMO) business, expanding essential medicine production domestically and demonstrating our capabilities in the global market. These steps position us well for further expansion opportunities ahead.</p>
            <p>Our strategic initiative in space medicine has yet to generate revenue or profits, yet we firmly believe in its necessity for humanity and our nation's long-term future. Through our "Humans In Space" initiative, we partnered officially with NASA’s Human Research Program last year and hosted a winning research team from the German Aerospace Center (DLR), thus creating an innovative ecosystem that fosters emerging space technologies.</p>
            <p>Meanwhile, our partner, Axiom Space, is actively competing for NASA’s Commercial LEO Destination (CLD) contracts and progressing steadily toward docking their first module at the International Space Station by early 2027. Boryung will not rely on Axiom's success alone. Instead, we'll continuously explore and develop unique opportunities—like building essential infrastructure in space medicine—that only we can pursue.</p>
            <!-- <p></p> -->
            <h3>■ Resource Allocation Going Forward</h3>
            <p>Allocating resources wisely is among management’s primary responsibilities. Our strategy involves effectively investing in both strengthening core businesses and nurturing strategic initiatives. This balanced investment encompasses financial resources and the invaluable assets of talent, infrastructure, and time.</p>
            <p>Our core pharmaceutical business will continue enhancing its competitive edge by developing and acquiring products leveraging our robust commercial infrastructure. Our production capabilities, validated by global original product manufacturing standards, will enable us to seize further domestic and international opportunities.</p>
            <p>For our strategic space healthcare business, we plan to shift from passive equity investments to actively leading projects, reinforcing our direct ownership and strategic control.</p>
            <p>Boryung’s leadership, including mine, commits to responsibly enhancing our core business and strategically developing future-oriented ventures through diligent resource allocation. This commitment aims to establish Boryung as a vital enterprise that is essential to humanity’s future.</p>
            <h3>■ Inspiring the Next Generation: Humans In Space (HIS) Youth</h3>
            <p>It is our duty as a corporation to create opportunities for future generations. Partnering with the Korea Foundation for Science and Creativity, Boryung launched the "HIS Youth" competition for elementary, middle, and high school students. Elementary students visualized a "Day on the International Space Station," while older students designed experiments addressing challenges of long-term space habitation, receiving mentorship from global experts and visiting NASA and Axiom Space.</p>
            <p>Artworks from 20 elementary teams will be sent to the ISS during Axiom’s Ax-4 mission in June, with plans for live sessions between the station and Korean students. As luck would have it, Jonny Kim—a Korean-American astronaut—will be aboard the International Space Station during that time. I can vividly imagine him introducing our children's artwork in Korean from orbit, which is a wonderful image. More importantly, it inspires me to dream of a day when an astronaut from Korea, aboard a space facility built by Korea, can directly communicate with our children and help them dream even bigger dreams.</p>
            <p>We intend to make this contest an annual tradition, believing strongly that it will help the next generation develop richer perspectives on our world and humankind.</p>
            <!-- <p></p>
            <p></p> -->
            <h3>■ Thoughts on the Annual Letter</h3>
            <p>I view our annual letter as a precious opportunity—one of candor, reflection, and learning. It provides us with a moment each year to honestly share our past decisions, discuss openly what we’ve learned from them, and clarify our direction going forward. Maintaining absolute transparency is my clear responsibility, and I firmly believe that sharing openly—both successes and mistakes—is integral to building lasting trust.</p>
            <p>True corporate value can never be boiled down to mere numbers on a balance sheet. Instead, it emerges from a more complex combination of purpose and meaning, company history, leadership vision, and our long-term direction. In these letters, I promise always to share my thoughts candidly and honestly. Through ongoing communication, I will continuously strive to deepen our common understanding—among shareholders, employees, and broader stakeholders—of what kind of company we aspire to become and how we intend to build lasting value.</p>
            <p>Lastly, this letter also gives me a unique chance to express gratitude that often goes unsaid. Boryung has reached today's position through many individuals’ extraordinary efforts and dedication. As it has been wisely said, "Those who forget history have no future." I sincerely appreciate to everyone who has contributed to our journey since the company's inception. I assure you their contributions are not forgotten, and I pledge to build upon the valuable legacy they have left us. My gratitude extends to former CEO Daniel Chang and all past leaders who have guided Boryung's success thus far.</p>
            <p class="date">2025.03.27</p>
            <p class="sign">CEO & Chairman, Jay Kim <img src="/images/mo/sign1.png" alt=""></p>
          </div>
        </div>
        <div class="btn-area">
          <LngLink to="ceo/2026/kim" class="btn-prev">2026 CEO LETTER</LngLink>
          <LngLink to="ceo/2024/kim" class="btn-prev">2024 CEO LETTER</LngLink>
        </div>
      </div>
    </div>
    <span class="v-bg"></span>
  </div>
</template>

<script>
import SelectContent from "@/views/components/SelectContent";
export default {
  name: "ceo",
  components: {SelectContent},
  data() {
    return {
      ready: true,
      refresh: true,
    }
  },
  mounted() {
    setTimeout(() => { this.ready = false },100);
    setTimeout(() => { this.refresh = false },1600);
  },
  computed: {
    active() {
      return this.$route.params.ceo
    },
    selectList() {
      return [
        {key: 'kim', label: 'gnb.ceo.kim'},
        // {key: 'chang', label: 'gnb.ceo.chang'}
      ]
    }
  },
  watch: {
    active() {
      this.refresh = true;
      setTimeout(() => { this.refresh = false },200)
    }
  },
  methods: {
    select(ceo) {
      if (this.active === ceo) return;
      this.$router.push({ params: { ceo } })
    }
  }
}
</script>

<style lang="less">
@import "~@/less/proj";
@use-rem: true;
@rem: 32;

[ceo] { 
  .fs(0); .p(0,70); .-box; .mt(140); .pb(200); .-box;
  .ceo-letter { 
    .mt(105);
    .cont {
      .tit { .fs(36); color:#6e675f; .lh(52); .ls(-0.05em); }
      .txt { .fs(24); .lh(36); .ls(-0.075em); .mt(40); .regular; text-align: justify;
        h3{ .fs(26); .mb(34); }
        h4{ .fs(25); .mb(32); }
        p { .mb(30);
          &.date { .m(50,0,0); .ib; }
          &.sign { .fs(30); .mt(15); .mb(0); .nowrap;
            &.en { .bold; }
          }
          i{
            font-style: italic;
          }
          +h3{
            .pt(30);
          }
          +h4{
            .pt(15);
          }
        }
        ol{
          .mt(-17);
          .pl(20);
          .mb(37);
          li{
            .fs(20);
            .ti(-17);
            .lh(30);
            .mb(5);
          }
        }
        img{
          .max-w(100%);
        }
      }
      &.cont1 {
        .txt .sign { .rel;
          img { .wh(171,68); .abs; .lt(360,-29); }
        }
      }
      &.cont2 {
        .txt .sign img { .wh(137,54); .ib; .vam; .m(-30,0,0,30); }
      }
    }
    .btn-area{
      .mt(90);
      opacity: 1;
      transition: opacity 0.8s;
      transition-delay: 2.6s;
      .btn-next, .btn-prev{
        .block();
        .fs(30);
        .bold;
        .w(fit-content);
        .-a(#2d2d2f);
        .p(20, 90, 20, 30);
        .m(10, 0, 0, auto);
        .rel();
        transition: background-color 0.5s;
        &:after {
          .cnt;
          .wh(35, 20);
          .contain("/images/mo/arr-r.png");
          .abs;
          .rt(30, 30);
        }
        &:hover {
          color: #fff;
          .bgc(#333132);
          &:after {
            .cnt;
            .contain("/images/mo/arr-r-w.png");
          }
        }
      }
    }
  }
  h2, .select-box, .cont .tit, .cont .txt > *, .v-bg { opacity:1; transform: translateY(0); transition: opacity 1s, transform 1s; transition-timing-function: ease-out; }
  .select-box { transition-delay: 0.8s; }
  .cont .tit { transition: opacity 0.8s, transform 0.8s; }
  .cont .txt > * { transition: opacity 0.8s, transform 0.8s;
    &:nth-child(1) { transition-delay: 0.4s; }
    &:nth-child(2) { transition-delay: 0.7s; }
    &:nth-child(3) { transition-delay: 1.0s; }
    &:nth-child(4) { transition-delay: 1.3s; }
    &:nth-child(5) { transition-delay: 1.6s; }
    &:nth-child(6) { transition-delay: 1.9s; }
    &:nth-child(n+7) { transition-delay: 2.2s; }
  }
  .v-bg { transform: translateX(0); transition-delay: 3.5s; }
  &.ready {
    h2, .select-box { opacity:0; transform: translateY(100px); }
    .v-bg { opacity:0; transform: translateX(-100%); }
  }
  .refresh {
    .cont .tit, .cont .txt > * { transition: opacity 0s, transform 0s; transition-delay: 0s; opacity:0; transform: translateY(100px); }
    .btn-area{ transition: opacity 0s; transition-delay: 0s; opacity: 0; }
  }
  .v-bg { .hide; }
}

#app {
  &.en [ceo] {
    [select-cont] .select-box ul li:nth-child(2) { .pr(60); .-box; }
    .ceo-letter .cont {
      &.cont1 {
        .txt .sign img { .lt(400,-32); }
      }
    }
  }
}
@media screen and(min-width: 1240px) {
  [ceo] { .p(180,0,0); .mt(0);
    .ceo-letter { .max-w(1240); .p(0,40,200,60); .-box; .mh-c; .mt(105);
      .cont {
        .txt { .fs(18); .lh(36); .mt(32); .keep-all;
          h3{ .fs(20); .mb(44); }
          h4{ .fs(19); .mb(42); }
          p { .mb(40);
            &.date { .fs(24); .m(10,0,0); }
            &.sign { .fs(24); .mt(10); .semi-bold; }
          }
          ol{
            .pl(17);
            li{
              .fs(16);
              .ti(-17);
            }
          }
        }
        &.cont1 {
          .txt .sign { .mt(15);
            img { .l(300); }
          }
        }
      }
      .btn-area{
        .tr();
        .mt(150);
      }
    }
    .v-bg { .wh(170,1141); .contain('/images/pc/boryung-ver.png'); .abs; .lt(50%,32); .ml(-690); .ib; }
  }
  #app {
    &.en [ceo] {
      [select-cont] .select-box ul li:nth-child(2) { .pr(0); }
      .ceo-letter{ 
        .cont {
          &.cont1 {
            .txt .sign img { .lt(320,-32); }
          }
        }
        .btn-area{
          .mt(120);
        }
      }
    }
  }
}
</style>